import React, { useState } from 'react';
import Filter from '../../../../../Asset/images/icon/Filters-lines.svg';
import FilterModal from '../../../../../component/FilterModal';
import ImportExportIcon from '@mui/icons-material/ImportExport';

const FilterSection = ({
	tags,
	category,
	sortby,
	setSortBy,
	selectedTags,
	selectedDurations,
	selectedLevels,
	selectedInstructors,
	selectedProducts,
	setSelectedTags,
	setSelectedDurations,
	setselectedLevels,
	setSelectedInstructors,
	setSelectedProducts,
	instructors,
	products,
	handleShuffle
}) => {
	const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

	const handleOpenFilterModal = () => {
		setIsFilterModalOpen(true);
	};

	const handleCloseFilterModal = () => {
		setIsFilterModalOpen(false);
	};

	const handleApplyFilter = (
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts
	) => {
		setSelectedTags(selectedTags);
		setselectedLevels(selectedLevels);
		setSelectedDurations(selectedDurations);
		setSelectedInstructors(selectedInstructors);
		setSelectedProducts(selectedProducts);
		setIsFilterModalOpen(false);
	};

	const handleFilterChange = event => {
		setSortBy(event.target.value);
	};

	return (
		<>
			<div className="c-tab_cata-text">
				<div id="c-mobile_tab_hide" className="c-tab_cata mb-n9">
					<div className="row m-0 c-tab_box">
						<div className="col p-0">
							<div className="c-filter_btn c-filter_btn-lessons">
								<div
									className="c-filter_btn-one c-filter_btn-tags unique"
									style={{ cursor: 'pointer', padding: '0px' }}
								>
									<span
										onClick={handleOpenFilterModal}
										className="c-filters-btn"
										style={{
											padding: '10px 12px',
											display: 'flex',
											justifyContent: 'space-between'
										}}
									>
										<img src={Filter} alt="" />
										Filters
									</span>
									{isFilterModalOpen && (
										<FilterModal
											isOpen={isFilterModalOpen}
											tags={tags}
											checkedTags={selectedTags}
											checkedDuration={selectedDurations}
											checkedLevels={selectedLevels}
											checkedInstructors={selectedInstructors}
											checkedProducts={selectedProducts}
											handleApplyFilter={handleApplyFilter}
											handleClose={handleCloseFilterModal}
											instructors={instructors}
											products={products}
										/>
									)}
								</div>
								<div className="c-filter_btn-one">
									<ImportExportIcon size={24} />
									<span>Sort by</span>
									<select className="filterby" onChange={handleFilterChange} value={sortby}>
										<option value={'latest'}>Newest</option>
										<option value={'oldest'}>Oldest</option>
										<option value={'title_asc'}>Title (A - Z)</option>
										<option value={'title_desc'}>Title (Z - A)</option>
										<option value={'long_duration'}>Longest</option>
										<option value={'short_duration'}>Shortest</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<h4>{category?.name}</h4>
			</div>
			<div className="c-video">
				<div className="row c-video_textrow c-video_list pb-0">
					<div className="col-md-8 c-video_textcol c-mobile_videotext-1">
						<h4>{category?.name}</h4>
					</div>
					<div className="col-md-4 c-video_textcol-a text-end c-mobile_videotext-2">
						<a onClick={() => handleShuffle(category?._id)}>
							<span style={{ color: '#3cb4e4' }}>
								<i className="fa-solid fa-shuffle"></i>
							</span>
							<span style={{ color: '#3cb4e4' }}>Shuffle</span>
						</a>
					</div>
				</div>
			</div>
		</>
	);
};

export default FilterSection;
